import _ from 'underscore';
import { includes } from '@bingads-webui-component-legacy/string/index';
import AggregateLengthSidebar from '@bingads-webui-component-legacy/form/view/sidebar/aggregate-length';

function aggregateLengthGenerator(schema) {
  const aggregateLengthConstraints = _.filter(schema.constraints, { type: 'aggregateLength' });

  return _.map(aggregateLengthConstraints, (constraint) => {
    return {
      properties: constraint.properties,
      view: AggregateLengthSidebar,
    };
  });
}

const generators = {
  aggregateLength: aggregateLengthGenerator,
};

function internalConvert(arraySidebars, strProperties) {
  return _.indexBy(arraySidebars, (sidebar) => {
    let strSidebarProperties = sidebar.properties.toString();

    if (!includes(strProperties, strSidebarProperties)) {
      throw new Error(`Some of properties ${strSidebarProperties} passed in through sidebars are not in passed in properties ${strProperties}`);
    }

    return strSidebarProperties;
  });
}

function bySchema(schema, properties) {
  const arraySidebars = _.reduce(generators, (memo, generator) => {
    return memo.concat(generator(schema));
  }, []);

  return internalConvert(arraySidebars, properties.toString());
}

export default function generate({ schema, properties, sidebars }) {
  const strProperties = properties.toString();

  return _.defaults(
    internalConvert(sidebars, strProperties),
    bySchema(schema, properties)
  );
}
